export const RENTAL_TYPE = {
    AVAILABLE: "0",
    RESERVED: "1",
    MAINTENANCE: "2",
    UNAVAILABLE: "3",
};
